import { render } from "./WebhookSlack.vue?vue&type=template&id=0b06fdf8"
import script from "./WebhookSlack.vue?vue&type=script&lang=js"
export * from "./WebhookSlack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__